import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function OpVitals(props) {
    const {cons_id} = useParams();
    const {appt_id} = useParams();
    const [inputValue, setInputValue] = useState('');
    const [appointment, setAppointment] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [conData, setConData] = useState({});
    const [registerFormData, setRegisterFormData] = useState({
        "weight": '',
        "height": '',
        "bmi": '',
        "tempr": '',
        "pulse": '',
        "bp": '',
        "spo2": '',
        "sugar": '',
        "allergy": '',
        "illness": '',
        "complaints": '',
        "diagnosis": '',
        "diet": '',
        "physio": '',
        "symptom": '',
        "examination": '',
        "review_date": '',
        "ip_status": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "view-appointment/" + appt_id)
            .then(response => {
                setAppointment(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchConData();
    }, []);
    function fetchConData() {
        axios.get(baseUrl + "view-consultform/" + appt_id)
            .then(response => {
                setConData(response.data);
                console.log(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const inputHandler = (event) => {
        const {name, value} = event.target;
        // Check if conData is available
        if (conData[0] != null) {
            const updatedConData = [{...conData[0], [name]: value}];
            // Calculate BMI if weight or height is updated
            if (name === 'weight' || name === 'height') {
                const weight = parseFloat(updatedConData[0].weight);
                const height = parseFloat(updatedConData[0].height);
                if (!isNaN(weight) && !isNaN(height) && height > 0) {
                    const bmi = (weight / ((height / 100) ** 2)).toFixed(2);
                    updatedConData[0].bmi = bmi;
                }
            }
            console.log('conData:', updatedConData);
            setConData(updatedConData);
        } else {
            const updatedRegisterFormData = {...registerFormData, [name]: value};
            // Calculate BMI if weight or height is updated
            if (name === 'weight' || name === 'height') {
                const weight = parseFloat(updatedRegisterFormData.weight);
                const height = parseFloat(updatedRegisterFormData.height);
                if (!isNaN(weight) && !isNaN(height) && height > 0) {
                    const bmi = (weight / ((height / 100) ** 2)).toFixed(2);
                    updatedRegisterFormData.bmi = bmi;
                }
            }
            setRegisterFormData(updatedRegisterFormData);
        }
    };
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
//        const symptoms = document.getElementById("symptoms").value;
        const apptId = appointment.map(row => row.id);
        const conId = conData.length > 0 ? conData[0].id : null;
        if (conId) {
            formData.append('appt', apptId);
            formData.append('weight', conData[0].weight);
            formData.append('height', conData[0].height);
            formData.append('bmi', conData[0].bmi);
            formData.append('tempr', conData[0].tempr);
            formData.append('pulse', conData[0].pulse);
            formData.append('bp', conData[0].bp);
            formData.append('spo2', conData[0].spo2);
            formData.append('sugar', conData[0].sugar);
            formData.append('allergy', conData[0].allergy);
            formData.append('illness', conData[0].illness);
            formData.append('complaints', conData[0].complaints);
            formData.append('diagnosis', conData[0].diagnosis);
            formData.append('diet', conData[0].diet);
            formData.append('physio', conData[0].physio);
//        formData.append('symptom',symptoms);
            formData.append('examination', conData[0].examination);
            formData.append('ip_add', ipAddress);
            formData.append('location', userLocation);
            axios.put(baseUrl + 'edit-case/' + conId + '/', formData)
                .then((response) => {
                    if (response.status == 200 || response.status == 201) {
                        Swal.fire({
                            title: 'Details Updated.',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        setTimeout(() => {
                            window.location.href = '/op-vitals/' + appt_id;
                        }, 2000);
                    }
                })
                .catch(error => {
                    console.log(error);
                    Swal.fire(
                        'Error!',
                        'Failed to update',
                        'error'
                    );
                });
        } else {
            formData.append('appt', apptId);
            formData.append('weight', registerFormData.weight);
            formData.append('height', registerFormData.height);
            formData.append('bmi', registerFormData.bmi);
            formData.append('tempr', registerFormData.tempr);
            formData.append('pulse', registerFormData.pulse);
            formData.append('bp', registerFormData.bp);
            formData.append('spo2', registerFormData.spo2);
            formData.append('sugar', registerFormData.sugar);
            formData.append('allergy', registerFormData.allergy);
            formData.append('illness', registerFormData.illness);
            formData.append('complaints', registerFormData.complaints);
            formData.append('diagnosis', registerFormData.diagnosis);
            formData.append('diet', registerFormData.diet);
            formData.append('physio', registerFormData.physio);
//        formData.append('symptom',symptoms);
            formData.append('examination', registerFormData.examination);
            formData.append('status', '1');
            formData.append('addedby', userName);
            formData.append('ip_add', ipAddress);
            formData.append('location', userLocation);
            axios.post(baseUrl + 'consultform/', formData)
                .then((response) => {
                    if (response.status == 200 || response.status == 201) {
                        Swal.fire({
                            title: 'Details has been added.',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        setTimeout(() => {
                            window.location.href = '/op-vitals/' + appt_id;
                        }, 2000);
                    }
                })
                .catch(error => {
                    console.log(error);
                    Swal.fire(
                        'Error!',
                        'Failed to Add. Please try again later.',
                        'error'
                    );
                });
        }
    };
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                Appointment of Dr.{appointment.map(row => row.cons.consultant)}
                <div style={{display: 'flex', marginLeft: '1rem'}}>
                    <Link to={`/vitals-view/`} className="btn btn-success ms-1">
                        Next
                    </Link>
                </div>
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {appointment.map((patientData, index) => (
                        <tr>
                   <td>
                                    <Link to={`/edit-patient/${patientData.pat.id}`}
                                          target="_blank">{patientData.pat.pat_id}</Link></td>
                            <td>{patientData.pat.patient}</td>
                            <td>{patientData.pat.gender}</td>
                            <td>{patientData.pat.age}</td>
                            <td>{patientData.pat.mobile}</td>
                            <td>{patientData.pat.add_date}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active border-success" id="nav-case-sheet-tab" data-bs-toggle="tab"
                            data-bs-target="#nav-case-sheet" type="button" role="tab" aria-controls="nav-case-sheet"
                            aria-selected="true">Case Sheet
                    </button>
                    <Link to={`/emr-details/${appointment.map(row => row.pat.pat_id)}`}>
                        <button className="nav-link  border-primary " id="nav-past-tab" data-bs-toggle="tab"
                                data-bs-target="#nav-past" type="button" role="tab" aria-controls="nav-past"
                                aria-selected="false">
                            Past Visit
                        </button>
                    </Link>
                </div>
            </nav>

            <div className="tab-content" id="nav-tabContent">

                <div className="tab-pane fade show active" id="nav-case-sheet" role="tabpanel"
                     aria-labelledby="nav-case-sheet-tab">
                    <form>
                        <div className="row mt-4">
                            <div className="col-md-2 mb-3">
                                <label htmlFor="Weight" className="form-label">Weight (Kg)</label>

                                <input type="number" maxLength={10} placeholder="Weight" className="form-control"
                                       name="weight"
                                       value={conData.length > 0 && conData[0].weight !== undefined ? conData[0].weight : registerFormData.weight}
                                       onChange={inputHandler}/>
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="Height" className="form-label">Height (cm)</label>
                                <input type="number" maxLength={10} placeholder="Height" className="form-control"
                                       name="height"
                                       value={conData.length > 0 && conData[0].height !== undefined ? conData[0].height : registerFormData.height}
                                       onChange={inputHandler}/>
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="BMI" className="form-label">BMI</label>
                                <input type="number" maxLength={10} placeholder="BMI" className="form-control"
                                       name="bmi"
                                       value={conData.length > 0 && conData[0].bmi !== undefined ? conData[0].bmi : registerFormData.bmi}
                                       onChange={inputHandler} readOnly/>
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="Tempr" className="form-label">Tempr.</label>
                                <input type="number" maxLength={10} placeholder="Tempr" className="form-control"
                                       name="tempr"
                                       value={conData.length > 0 && conData[0].tempr !== undefined ? conData[0].tempr : registerFormData.tempr}
                                       onChange={inputHandler}/>
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="Pulse" className="form-label">Pulse</label>
                                <input type="number" maxLength={10} placeholder="Pulse" className="form-control"
                                       name="pulse"
                                       value={conData.length > 0 && conData[0].pulse !== undefined ? conData[0].pulse : registerFormData.pulse}
                                       onChange={inputHandler}/>
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="BP(Sys/Dias)" className="form-label">BP (Sys/Dias)</label>
                                <input type="text" maxLength={10} placeholder="BP(Sys/Dias)" className="form-control"
                                       name="bp"
                                       value={conData.length > 0 && conData[0].bp !== undefined ? conData[0].bp : registerFormData.bp}
                                       onChange={inputHandler}/>
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="SPO2" className="form-label">SPO2</label>
                                <input type="number" maxLength={10} placeholder="SPO2" className="form-control"
                                       name="spo2"
                                       value={conData.length > 0 && conData[0].spo2 !== undefined ? conData[0].spo2 : registerFormData.spo2}
                                       onChange={inputHandler}/>
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="Sugar" className="form-label">Sugar</label>
                                <input type="number" maxLength={10} placeholder="Sugar" className="form-control"
                                       name="sugar"
                                       value={conData.length > 0 && conData[0].sugar !== undefined ? conData[0].sugar : registerFormData.sugar}
                                       onChange={inputHandler}/>
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-12 text-center mb-5">
                                <button type="button" onClick={submitHandler}
                                        className="btn btn-success">Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </section>
    )
}
export default OpVitals;